import {isEmpty} from 'lodash'

const initialState = {
  employement: {
    employer: "",
    address: "",
    phoneNumber: "",
    occupation: "",
    jobStartedDate: "",
    jobEndedDate: "",
    workingHoursWeekly: "",
    paidGross: "",
    salaryType: "1",
  },

  ageAndEducation: {
    age: "",
    isHighSchoolDegreeCompleted: "",
    NumberOfYearsCollege: "",
    specifyCollegeDegree: "",
    NumberOfYearsGraduates: "",
    specifyGraduateDegree: "",
    professionalOccupational: "",
    vocationalTraining: "",
  },

  taxInformation: {
    lastTaxYear: "",
    spouseName: "",
    californiaState: "",
    taxFilingStatus: "",
    taxReturnState: "",
    exemptionsOnTax: "",
    outSideCalifornia: "",
  },

  otherPartyIncome: {
    grossMonthallyIncome: "",
    estimateBasedOn: "",
  },

  income: {
    salaryWages: {
      lastMonth: 0.0,
      averageMonthally: 0.0,
    },
    overtime: {
      lastMonth: 0.0,
      averageMonthally: 0.0,
    },
    commissions: {
      lastMonth: "",
      averageMonthally: "",
    },
    publicAssistance: {
      currentlyReceivingCheck: "0",
      lastMonth: "",
      averageMonthally: "",
    },
    spousalSuport: {
      spousalSuportCheck: [],
      lastMonth: "",
      averageMonthally: "",
    },
    partnerSupport: {
      partnerSupportCheck: [],
      lastMonth: "",
      averageMonthally: "",
    },
    socialSecurity: {
      lastMonth: "",
      averageMonthally: "",
    },
    disability: {
      disabilityCheck: [],
      lastMonth: "",
      averageMonthally: "",
    },
    pensionRetirementFund: {
      lastMonth: "",
      averageMonthally: "",
    },
    unemploymentCompensation: {
      lastMonth: "",
      averageMonthally: "",
    },
    WorkerCompensation: {
      lastMonth: "",
      averageMonthally: "",
    },
    others: {
      specific: "",
      lastMonth: "",
      averageMonthally: "",
    },
  },

  investmentIncome: {
    dividendsInterest: {
      lastMonth: "",
      averageMonthally: "",
    },
    rentalPropertyIncome: {
      lastMonth: "",
      averageMonthally: "",
    },
    trustIncome: {
      lastMonth: "",
      averageMonthally: "",
    },
    otherIncome: {
      specific: "",
      lastMonth: "",
      averageMonthally: "",
    },
  },

  IncomeFromSelfEmployment: {
    selfEmployementType: {
      selfEmployementTypeStatus: "",
      bussinessPartner: {
        specify: "",
      },
    },
    yearsOfBusiness: "",
    businessName: "",
    businessType: "",
  },

  oneTimeMoney: {
    specific: "",
  },

  changeInIncome: "",

  deductions: {
    requiredUnionDues: {
      lastMonth: "",
    },
    requiredRetirementPay: {
      lastMonth: "",
    },
    healthExpenses: {
      lastMonth: "",
    },
    childSupport: {
      lastMonth: "",
    },
    spousalSupport: {
      lastMonth: "",
      federallytax: "-1",
    },
    partnerSupport: {
      lastMonth: "",
    },
    jobExpenses: {
      lastMonth: "",
    },
  },

  assets: {
    accounts: {
      lastMonth: "",
    },
    stockBonds: {
      lastMonth: "",
    },
    otherPropert: {
      type: "",
      lastMonth: "",
    },
  },

  averageMonthallyExpenses: {
    home: {
      
      homeStatus: {
        averageMonthlyExpenseBox : [],
        rent: "-1",
        mortgage: {
          averagePrincipal: "",
          averageIntrest: "",
        },
        rental:{
          rentalCost:"",
        },
      },
      realPropertyTax: {
        lastMonth: "",
      },
      homeOwnerInsurance: {
        lastMonth: "",
      },
      maintainance: {
        lastMonth: "",
      },
    },
    healthCareCost: {
      lastMonth: "",
    },
    childCareCost: {
      lastMonth: "",
    },
    householdSupplies: {
      lastMonth: "",
    },
    eatingOut: {
      lastMonth: "",
    },
    utilities: {
      lastMonth: "",
    },
    telephone: {
      lastMonth: "",
    },
    laundaryCleaning: {
      lastMonth: "",
    },
    clothes: {
      lastMonth: "",
    },
    education: {
      lastMonth: "",
    },
    entertainment: {
      lastMonth: "",
    },
    transportation: {
      lastMonth: "",
    },
    insurance: {
      lastMonth: "",
    },
    savingsInvestments: {
      lastMonth: "",
    },
    charitableContributions: {
      lastMonth: "",
    },
    monthallyPayments: {
      lastMonth: "",
    },
    others: {
      specific: "",
      lastMonth: "",
    },
    totalExpense: "",
    amountPaidByOthers: "",
  },

  attorneyFees: {
    no: "",
    yes: {
      attorneyMonthallyFees: {
        lastMonth: "",
      },
      sourceOfMoney: "",
      totalOwedFee: {
        lastMonth: "",
      },
      attorneyHourlyRate: {
        lastMonth: "",
      },
    },
  },

  numberOfChildren: {
    NumberOfunderAgeChild: "",
    timeSpendWithYouPercentage: "",
    timeSpendWithSpousePercentage: "",
  },

  childHealthCareExpense: {
    no: "",
    yes: {
      insuranceCompanyName: "",
      insuranceCompanyAddress: "",
      monthallyCost: "",
    },
  },

  additionalChildExpense: {
    childCare: "",
    childHealthCare: "",
    childTravelExpense: "",
    childOtherSpecialNeeds: {
      specific: "",
      lastMonth: "",
    },
  },

  specialHardship: {
    childrenSpecify : "",
    extraHealthExpenses: {
      lastMonth: "",
      averageMonthally: "",
    },

    majorLoss: {
      lastMonth: "",
      averageMonthally: "",
    },

    minorChildExpense: {
      lastMonth: "",
      averageMonthally: "",
    },
    minorChildSupport: "",
    financialHardshipExplain: "",
  },

  otherInfoForCourt: "",

  peopleLive: [{
    name: "",
    age: "",
    person_related: "",
    person_monthly_income: "",
    household_expenses: "",
  }],

  installmentPayments: [{
    toPaymentInstallment: "",
    forPaymentInstallment: "",
    amountInstallment: "",
    balanceInstallment: "",
    dateLastInstallment: "",
  }],

  isFecthingPostData: false,
  isFecthingAgeEducation: false,
  isFecthingTaxInformation: false,
  isFetchingOtherPartyIncome: false,
  isFetchingIncome: false,
  isFetchingInvestIncome: false,
  isFetchingEmplayedIncome: false,
  isFetchingChangeInIncome: false,
  isFetchingDeductions: false,
  isFetchingAsset: false,
  isFetchingAverageMonthallyExpense: false,
  isFetchingAttorneyFee: false,
  isFetchingNumberOfChildre: false,
  isFetchingChildHealthExpense: false,
  isFetchingChildAdditionalExpense: false,
  isFetchingSpecialHardship: false,
  isFetchingOtherInformation: false,
  isFetchingAdditionalIncome: false,
  isFetchingPeopleLive: false,
  isFetchingInstallmentPayments: false,
  isFetchingDeletePeopleLive: false,
  isFetchingDeleteInstallment: false,
  isFecthingAllData: false,
};
const AssestsDebitsReducer = (state = initialState, action) => {
  switch (action.type) {

    //GET CALL

    case "REQUEST_ALL_ASSET_DEBIT_DATA":
      return { ...state, employement: {
        employer: "",
        address: "",
        phoneNumber: "",
        occupation: "",
        jobStartedDate: "",
        jobEndedDate: "",
        workingHoursWeekly: "",
        paidGross: "",
        salaryType: 1,
      },
    
      ageAndEducation: {
        age: "",
        isHighSchoolDegreeCompleted: "",
        NumberOfYearsCollege: "",
        specifyCollegeDegree: "",
        NumberOfYearsGraduates: "",
        specifyGraduateDegree: "",
        professionalOccupational: "",
        vocationalTraining: "",
      },
    
      taxInformation: {
        lastTaxYear: "",
        spouseName: "",
        californiaState: "",
        taxFilingStatus: "",
        taxReturnState: "",
        exemptionsOnTax: "",
        outSideCalifornia: "",
      },
    
      otherPartyIncome: {
        grossMonthallyIncome: "",
        estimateBasedOn: "",
      },
    
      income: {
        salaryWages: {
          lastMonth: 0.0,
          averageMonthally: 0.0,
        },
        overtime: {
          lastMonth: "",
          averageMonthally: "",
        },
        commissions: {
          lastMonth: "",
          averageMonthally: "",
        },
        publicAssistance: {
          currentlyReceivingCheck: "",
          lastMonth: "",
          averageMonthally: "",
        },
        spousalSuport: {
          spousalSuportCheck: [],
          lastMonth: "",
          averageMonthally: "",
        },
        partnerSupport: {
          partnerSupportCheck: [],
          lastMonth: "",
          averageMonthally: "",
        },
        socialSecurity: {
          lastMonth: "",
          averageMonthally: "",
        },
        disability: {
          disabilityCheck: [],
          lastMonth: "",
          averageMonthally: "",
        },
        pensionRetirementFund: {
          lastMonth: "",
          averageMonthally: "",
        },
        unemploymentCompensation: {
          lastMonth: "",
          averageMonthally: "",
        },
        WorkerCompensation: {
          lastMonth: "",
          averageMonthally: "",
        },
        others: {
          specific: "",
          lastMonth: "",
          averageMonthally: "",
        },
      },
    
      investmentIncome: {
        dividendsInterest: {
          lastMonth: "",
          averageMonthally: "",
        },
        rentalPropertyIncome: {
          lastMonth: "",
          averageMonthally: "",
        },
        trustIncome: {
          lastMonth: "",
          averageMonthally: "",
        },
        otherIncome: {
          specific: "",
          lastMonth: "",
          averageMonthally: "",
        },
      },
    
      IncomeFromSelfEmployment: {
        selfEmployementType: {
          selfEmployementTypeStatus: "",
          bussinessPartner: {
            specify: "",
          },
        },
        yearsOfBusiness: "",
        businessName: "",
        businessType: "",
      },
    
      oneTimeMoney: {
        specific: "",
      },
    
      changeInIncome: "",
    
      deductions: {
        requiredUnionDues: {
          lastMonth: "",
        },
        requiredRetirementPay: {
          lastMonth: "",
        },
        healthExpenses: {
          lastMonth: "",
        },
        childSupport: {
          lastMonth: "",
        },
        spousalSupport: {
          lastMonth: "",
          federallytax: "0",
        },
        partnerSupport: {
          lastMonth: "",
        },
        jobExpenses: {
          lastMonth: "",
        },
      },
    
      assets: {
        accounts: {
          lastMonth: "",
        },
        stockBonds: {
          lastMonth: "",
        },
        otherPropert: {
          type: "",
          lastMonth: "",
        },
      },
    
      averageMonthallyExpenses: {
        home: {
          
          homeStatus: {
            averageMonthlyExpenseBox : [],
            rent: "-1",
            mortgage: {
              averagePrincipal: "",
              averageIntrest: "",
            },
            rental:{
              rentalCost:"",
            },
          },
          realPropertyTax: {
            lastMonth: "",
          },
          homeOwnerInsurance: {
            lastMonth: "",
          },
          maintainance: {
            lastMonth: "",
          },
        },
        healthCareCost: {
          lastMonth: "",
        },
        childCareCost: {
          lastMonth: "",
        },
        householdSupplies: {
          lastMonth: "",
        },
        eatingOut: {
          lastMonth: "",
        },
        utilities: {
          lastMonth: "",
        },
        telephone: {
          lastMonth: "",
        },
        laundaryCleaning: {
          lastMonth: "",
        },
        clothes: {
          lastMonth: "",
        },
        education: {
          lastMonth: "",
        },
        entertainment: {
          lastMonth: "",
        },
        transportation: {
          lastMonth: "",
        },
        insurance: {
          lastMonth: "",
        },
        savingsInvestments: {
          lastMonth: "",
        },
        charitableContributions: {
          lastMonth: "",
        },
        monthallyPayments: {
          lastMonth: "",
        },
        others: {
          specific: "",
          lastMonth: "",
        },
        totalExpense: "",
        amountPaidByOthers: "",
      },
    
      attorneyFees: {
        no: "",
        yes: {
          attorneyMonthallyFees: {
            lastMonth: "",
          },
          sourceOfMoney: "",
          totalOwedFee: {
            lastMonth: "",
          },
          attorneyHourlyRate: {
            lastMonth: "",
          },
        },
      },
    
      numberOfChildren: {
        NumberOfunderAgeChild: "",
        timeSpendWithYouPercentage: "",
        timeSpendWithSpousePercentage: "",
      },
    
      childHealthCareExpense: {
        no: "",
        yes: {
          insuranceCompanyName: "",
          insuranceCompanyAddress: "",
          monthallyCost: "",
        },
      },
    
      additionalChildExpense: {
        childCare: "",
        childHealthCare: "",
        childTravelExpense: "",
        childOtherSpecialNeeds: {
          specific: "",
          lastMonth: "",
        },
      },
    
      specialHardship: {
        childrenSpecify : "",
        extraHealthExpenses: {
          lastMonth: "",
          averageMonthally: "",
        },
    
        majorLoss: {
          lastMonth: "",
          averageMonthally: "",
        },
    
        minorChildExpense: {
          lastMonth: "",
          averageMonthally: "",
        },
        minorChildSupport: "",
        financialHardshipExplain: "",
      },
    
      otherInfoForCourt: "",
    
      peopleLive: [{
        name: "",
        age: "",
        person_related: "",
        person_monthly_income: "",
        household_expenses: "",
      }],
    
      installmentPayments: [{
        toPaymentInstallment: "",
        forPaymentInstallment: "",
        amountInstallment: "",
        balanceInstallment: "",
        dateLastInstallment: "",
      }],
    
      isFecthingPostData: false,
      isFecthingAgeEducation: false,
      isFecthingTaxInformation: false,
      isFetchingOtherPartyIncome: false,
      isFetchingIncome: false,
      isFetchingInvestIncome: false,
      isFetchingEmplayedIncome: false,
      isFetchingChangeInIncome: false,
      isFetchingDeductions: false,
      isFetchingAsset: false,
      isFetchingAverageMonthallyExpense: false,
      isFetchingAttorneyFee: false,
      isFetchingNumberOfChildre: false,
      isFetchingChildHealthExpense: false,
      isFetchingChildAdditionalExpense: false,
      isFetchingSpecialHardship: false,
      isFetchingOtherInformation: false,
      isFetchingAdditionalIncome: false,
      isFetchingPeopleLive: false,
      isFetchingInstallmentPayments: false,
      isFetchingDeletePeopleLive: false,
      isFetchingDeleteInstallment: false,
      isFecthingAllData: true };
    case "SUCCESS_ALL_ASSET_DEBIT_DATA":
      return {
        ...state,
        employement: {
          employer: action.payload.data.employement.employer,
          address: action.payload.data.employement.address,
          phoneNumber: action.payload.data.employement.phoneNumber,
          occupation: action.payload.data.employement.occupation,
          jobStartedDate: action.payload.data.employement.jobStartedDate,
          jobEndedDate: action.payload.data.employement.jobEndedDate,
          workingHoursWeekly: action.payload.data.employement.workingHoursWeekly,
          paidGross: action.payload.data.employement.paidGross,
          salaryType: action.payload.data.employement.salaryType,
        },

        ageAndEducation: {
          age: action.payload.data.ageAndEducation.age,
          isHighSchoolDegreeCompleted: action.payload.data.ageAndEducation.isHighSchoolDegreeCompleted,
          NumberOfYearsCollege: action.payload.data.ageAndEducation.NumberOfYearsCollege,
          specifyCollegeDegree: action.payload.data.ageAndEducation.specifyCollegeDegree,
          NumberOfYearsGraduates: action.payload.data.ageAndEducation.NumberOfYearsGraduates,
          specifyGraduateDegree: action.payload.data.ageAndEducation.specifyGraduateDegree,
          professionalOccupational: action.payload.data.ageAndEducation.professionalOccupational,
          vocationalTraining: action.payload.data.ageAndEducation.vocationalTraining,
        },

        taxInformation: {

          lastTaxYear: action.payload.data.taxInformation.lastTaxYear,
          spouseName: action.payload.data.taxInformation.spouseName,
          californiaState: action.payload.data.taxInformation.californiaState,
          taxFilingStatus: action.payload.data.taxInformation.taxFilingStatus,
          taxReturnState: action.payload.data.taxInformation.taxReturnState,
          exemptionsOnTax: action.payload.data.taxInformation.exemptionsOnTax,
          outSideCalifornia: action.payload.data.taxInformation.outSideCalifornia,
        },

        otherPartyIncome: {
          grossMonthallyIncome: action.payload.data.otherPartyIncome.grossMonthallyIncome,
          estimateBasedOn: action.payload.data.otherPartyIncome.estimateBasedOn,
        },

        income: {
          salaryWages: {
            lastMonth: action.payload.data.income.salaryWages.lastMonth,
            averageMonthally: action.payload.data.income.salaryWages.averageMonthally,
          },
          overtime: {
            lastMonth: action.payload.data.income.overtime.lastMonth,
            averageMonthally: action.payload.data.income.overtime.averageMonthally,
          },
          commissions: {
            lastMonth: action.payload.data.income.commissions.lastMonth,
            averageMonthally: action.payload.data.income.commissions.averageMonthally,
          },
          publicAssistance: {
            currentlyReceivingCheck: action.payload.data.income.publicAssistance.currentlyReceivingCheck,
            lastMonth: action.payload.data.income.publicAssistance.lastMonth,
            averageMonthally: action.payload.data.income.publicAssistance.averageMonthally,
          },
          spousalSuport: {
            spousalSuportCheck: action.payload.data.income.spousalSuport.spousalSuportCheck,
            lastMonth: action.payload.data.income.spousalSuport.lastMonth,
            averageMonthally: action.payload.data.income.spousalSuport.averageMonthally,
          },
          disability: {
            disabilityCheck: action.payload.data.income.disability.disabilityCheck,
            lastMonth: action.payload.data.income.disability.lastMonth,
            averageMonthally: action.payload.data.income.disability.averageMonthally,
          },
          partnerSupport: {
            partnerSupportCheck: action.payload.data.income.partnerSupport.partnerSupportCheck,
            lastMonth: action.payload.data.income.partnerSupport.lastMonth,
            averageMonthally: action.payload.data.income.partnerSupport.averageMonthally,
          },
          socialSecurity: {
            lastMonth: action.payload.data.income.socialSecurity.lastMonth,
            averageMonthally: action.payload.data.income.socialSecurity.averageMonthally,
          },
          pensionRetirementFund: {
            lastMonth: action.payload.data.income.pensionRetirementFund.lastMonth,
            averageMonthally: action.payload.data.income.pensionRetirementFund.averageMonthally,
          },
          unemploymentCompensation: {
            lastMonth: action.payload.data.income.unemploymentCompensation.lastMonth,
            averageMonthally: action.payload.data.income.unemploymentCompensation.averageMonthally,
          },
          WorkerCompensation: {
            lastMonth: action.payload.data.income.WorkerCompensation.lastMonth,
            averageMonthally: action.payload.data.income.WorkerCompensation.averageMonthally,
          },
          others: {
            specific: action.payload.data.income.others.specific,
            lastMonth: action.payload.data.income.others.lastMonth,
            averageMonthally: action.payload.data.income.others.averageMonthally,
          },
        },

        investmentIncome: {
          dividendsInterest: {
            lastMonth: action.payload.data.investmentIncome.dividendsInterest.lastMonth,
            averageMonthally: action.payload.data.investmentIncome.dividendsInterest.averageMonthally,
          },
          rentalPropertyIncome: {
            lastMonth: action.payload.data.investmentIncome.rentalPropertyIncome.lastMonth,
            averageMonthally: action.payload.data.investmentIncome.rentalPropertyIncome.averageMonthally,
          },
          trustIncome: {
            lastMonth: action.payload.data.investmentIncome.trustIncome.lastMonth,
            averageMonthally: action.payload.data.investmentIncome.trustIncome.averageMonthally,
          },
          otherIncome: {
            specific: action.payload.data.investmentIncome.otherIncome.specific,
            lastMonth: action.payload.data.investmentIncome.otherIncome.lastMonth,
            averageMonthally: action.payload.data.investmentIncome.otherIncome.averageMonthally,
          },
        },


        IncomeFromSelfEmployment: {
          selfEmployementType: {
            selfEmployementTypeStatus: action.payload.data.IncomeFromSelfEmployment.selfEmployementType.selfEmployementTypeStatus,
            bussinessPartner: {
              specify: action.payload.data.IncomeFromSelfEmployment.selfEmployementType.bussinessPartner.specify,
            },
          },
          yearsOfBusiness: action.payload.data.IncomeFromSelfEmployment.yearsOfBusiness,
          businessName: action.payload.data.IncomeFromSelfEmployment.businessName,
          businessType: action.payload.data.IncomeFromSelfEmployment.businessType,
        },

        oneTimeMoney: {
          specific: action.payload.data.oneTimeMoney.specific,
        },

        changeInIncome: action.payload.data.changeInIncome,

        deductions: {
          requiredUnionDues: {
            lastMonth: action.payload.data.deductions.requiredUnionDues.lastMonth,
          },
          requiredRetirementPay: {
            lastMonth: action.payload.data.deductions.requiredRetirementPay.lastMonth,
          },
          healthExpenses: {
            lastMonth: action.payload.data.deductions.healthExpenses.lastMonth,
          },
          childSupport: {
            lastMonth: action.payload.data.deductions.childSupport.lastMonth,
          },
          spousalSupport: {
            lastMonth: action.payload.data.deductions.spousalSupport.lastMonth,
            federallytax: action.payload.data.deductions.spousalSupport.federallytax,
          },
          partnerSupport: {
            lastMonth: action.payload.data.deductions.partnerSupport.lastMonth,
          },
          jobExpenses: {
            lastMonth: action.payload.data.deductions.jobExpenses.lastMonth,
          },
        },

        assets: {
          accounts: {
            lastMonth: action.payload.data.assets.accounts.lastMonth,
          },
          stockBonds: {
            lastMonth: action.payload.data.assets.stockBonds.lastMonth,
          },
          otherPropert: {
            type: action.payload.data.assets.otherPropert.type,
            lastMonth: action.payload.data.assets.otherPropert.lastMonth,
          },
        },

        averageMonthallyExpenses: {
          home: {
            homeStatus: {
              averageMonthlyExpenseBox : action.payload.data.averageMonthallyExpenses.home.homeStatus.averageMonthlyExpenseBox,
              rent: action.payload.data.averageMonthallyExpenses.home.homeStatus.rent,
              mortgage: {
                averagePrincipal: action.payload.data.averageMonthallyExpenses.home.homeStatus.mortgage.averagePrincipal,
                averageIntrest: action.payload.data.averageMonthallyExpenses.home.homeStatus.mortgage.averageIntrest,
              },
              rental:{
                rentalCost: action.payload.data.averageMonthallyExpenses.home.homeStatus.rental.rentalCost,
              },
            },
            realPropertyTax: {
              lastMonth: action.payload.data.averageMonthallyExpenses.home.realPropertyTax.lastMonth,
            },
            homeOwnerInsurance: {
              lastMonth: action.payload.data.averageMonthallyExpenses.home.homeOwnerInsurance.lastMonth,
            },
            maintainance: {
              lastMonth: action.payload.data.averageMonthallyExpenses.home.maintainance.lastMonth,
            },
          },
          healthCareCost: {
            lastMonth: action.payload.data.averageMonthallyExpenses.healthCareCost.lastMonth,
          },
          childCareCost: {
            lastMonth: action.payload.data.averageMonthallyExpenses.childCareCost.lastMonth,
          },
          householdSupplies: {
            lastMonth: action.payload.data.averageMonthallyExpenses.householdSupplies.lastMonth,
          },
          eatingOut: {
            lastMonth: action.payload.data.averageMonthallyExpenses.eatingOut.lastMonth,
          },
          utilities: {
            lastMonth: action.payload.data.averageMonthallyExpenses.utilities.lastMonth,
          },
          telephone: {
            lastMonth: action.payload.data.averageMonthallyExpenses.telephone.lastMonth,
          },
          laundaryCleaning: {
            lastMonth: action.payload.data.averageMonthallyExpenses.laundaryCleaning.lastMonth,
          },
          clothes: {
            lastMonth: action.payload.data.averageMonthallyExpenses.clothes.lastMonth,
          },
          education: {
            lastMonth: action.payload.data.averageMonthallyExpenses.education.lastMonth,
          },
          entertainment: {
            lastMonth: action.payload.data.averageMonthallyExpenses.entertainment.lastMonth,
          },
          transportation: {
            lastMonth: action.payload.data.averageMonthallyExpenses.transportation.lastMonth,
          },
          insurance: {
            lastMonth: action.payload.data.averageMonthallyExpenses.insurance.lastMonth,
          },
          savingsInvestments: {
            lastMonth: action.payload.data.averageMonthallyExpenses.savingsInvestments.lastMonth,
          },
          charitableContributions: {
            lastMonth: action.payload.data.averageMonthallyExpenses.charitableContributions.lastMonth,
          },
          monthallyPayments: {
            lastMonth: action.payload.data.averageMonthallyExpenses.monthallyPayments.lastMonth,
          },
          others: {
            specific: action.payload.data.averageMonthallyExpenses.others.specific,
            lastMonth: action.payload.data.averageMonthallyExpenses.others.lastMonth,
          },
          totalExpense: action.payload.data.averageMonthallyExpenses.totalExpense,
          amountPaidByOthers: action.payload.data.averageMonthallyExpenses.amountPaidByOthers,
        },

        attorneyFees: {
          no: action.payload.data.attorneyFees.no,
          yes: {
            attorneyMonthallyFees: {
              lastMonth: action.payload.data.attorneyFees.yes.attorneyMonthallyFees.lastMonth,
            },
            sourceOfMoney: action.payload.data.attorneyFees.yes.sourceOfMoney,
            totalOwedFee: {
              lastMonth: action.payload.data.attorneyFees.yes.totalOwedFee.lastMonth,
            },
            attorneyHourlyRate: {
              lastMonth: action.payload.data.attorneyFees.yes.attorneyHourlyRate.lastMonth,
            },
          },
        },

        numberOfChildren: {
          NumberOfunderAgeChild: action.payload.data.numberOfChildren.NumberOfunderAgeChild,
          timeSpendWithYouPercentage: action.payload.data.numberOfChildren.timeSpendWithYouPercentage,
          timeSpendWithSpousePercentage: action.payload.data.numberOfChildren.timeSpendWithSpousePercentage,
        },

        childHealthCareExpense: {
          no: action.payload.data.childHealthCareExpense.no,
          yes: {
            insuranceCompanyName: action.payload.data.childHealthCareExpense.yes.insuranceCompanyName,
            insuranceCompanyAddress: action.payload.data.childHealthCareExpense.yes.insuranceCompanyAddress,
            monthallyCost: action.payload.data.childHealthCareExpense.yes.monthallyCost,
          },
        },

        additionalChildExpense: {
          childCare: action.payload.data.additionalChildExpense.childCare,
          childHealthCare: action.payload.data.additionalChildExpense.childHealthCare,
          childTravelExpense: action.payload.data.additionalChildExpense.childTravelExpense,
          childOtherSpecialNeeds: {
            specific: action.payload.data.additionalChildExpense.childOtherSpecialNeeds.specific,
            lastMonth: action.payload.data.additionalChildExpense.childOtherSpecialNeeds.lastMonth,
          },
        },

        specialHardship: {
          childrenSpecify: action.payload.data.specialHardship.childrenSpecify,
          extraHealthExpenses: {
            lastMonth: action.payload.data.specialHardship.extraHealthExpenses.lastMonth,
            averageMonthally: action.payload.data.specialHardship.extraHealthExpenses.averageMonthally,
          },

          majorLoss: {
            lastMonth: action.payload.data.specialHardship.majorLoss.lastMonth,
            averageMonthally: action.payload.data.specialHardship.majorLoss.averageMonthally,
          },

          minorChildExpense: {
            lastMonth: action.payload.data.specialHardship.minorChildExpense.lastMonth,
            averageMonthally: action.payload.data.specialHardship.minorChildExpense.averageMonthally,
          },
          minorChildSupport: action.payload.data.specialHardship.minorChildSupport,
          financialHardshipExplain: action.payload.data.specialHardship.financialHardshipExplain,
        },

        otherInfoForCourt: action.payload.data.otherInfoForCourt,

        peopleLive: action.payload.data.peopleLive,

        installmentPayments: action.payload.data.installmentPayments,

        isFecthingAllData: false,
      };
    case "ERROR_ALL_ASSET_DEBIT_DATA":
      return { ...state, isFecthingAllData: false };





    //POST CALL

    case "REQUEST_ASSET_DEBIT_DATA":
      return { ...state, isFecthingPostData: true };
    case "SUCCESS_ASSET_DEBIT_DATA":
      return {
        ...state,
        isFecthingPostData: false,
      };
    case "ERROR_ASSET_DEBIT_DATA":
      return { ...state, isFecthingPostData: false };

    //EMPLOYEMENT_DETAILS

    case "REQUEST_EMPLOYEMENT_DETAILS":
      return { ...state, isFecthingPostData: true };
    case "SUCCESS_EMPLOYEMENT_DETAILS":
      return {
        ...state,
        employement: {
          employer: action.payload.employer,
          address: action.payload.address,
          phoneNumber: action.payload.phoneNumber,
          occupation: action.payload.occupation,
          jobStartedDate: action.payload.jobStartedDate,
          jobEndedDate: action.payload.jobEndedDate,
          workingHoursWeekly: action.payload.workingHoursWeekly,
          paidGross: action.payload.paidGross,
          salaryType: action.payload.salaryType,
        },
        isFecthingPostData: false,
      };
    case "ERROR_EMPLOYEMENT_DETAILS":
      return { ...state, isFecthingPostData: false };

    //Age and Education

    case "REQUEST_AGE_EDUCATION":
      return { ...state, isFecthingAgeEducation: true };
    case "SUCCESS_AGE_EDUCATION":
      return {
        ...state,
        ageAndEducation: {
          age: action.payload.age,
          isHighSchoolDegreeCompleted: action.payload.highSchoolDegree,
          NumberOfYearsCollege: action.payload.noOfCollegeYears,
          specifyCollegeDegree: action.payload.collegeDegreeName,
          NumberOfYearsGraduates: action.payload.noOfGraduateYears,
          specifyGraduateDegree: action.payload.garduateDegreeName,
          professionalOccupational: action.payload.professionalOccupationalValue,
          vocationalTraining: action.payload.vocationalTrainingValue,
        },
        isFecthingAgeEducation: false,
      };
    case "ERROR_AGE_EDUCATION":
      return { ...state, isFecthingAgeEducation: false };

    //TAX INFORMATON

    case "REQUEST_TAX_INFORMATION":
      return { ...state, isFecthingTaxInformation: true };
    case "SUCCESS_TAX_INFORMATION":
      return {
        ...state,
        taxInformation: {
          lastTaxYear: action.payload.taxYear,
          spouseName: action.payload.spouseName,
          californiaState: action.payload.californiaState,
          taxFilingStatus: action.payload.taxFilingStatus,
          taxReturnState: action.payload.fileTaxState,
          exemptionsOnTax: action.payload.exemptionsOnTaxt,
          outSideCalifornia: action.payload.outSideCalifornia,
        },
        isFecthingTaxInformation: false,
      };
    case "ERROR_TAX_INFORMATION":
      return { ...state, isFecthingTaxInformation: false };

    //OTHER PARTY INCOME
    case "REQUEST_OTHER_PARTY_INCOME":
      return { ...state, isFetchingOtherPartyIncome: true };
    case "SUCCESS_OTHER_PARTY_INCOME":
      return {
        ...state,
        otherPartyIncome: {
          grossMonthallyIncome: action.payload.otherPartyIncome,
          estimateBasedOn: action.payload.estimateBasedOn,
        },
        isFetchingOtherPartyIncome: false,
      };
    case "ERROR_OTHER_PARTY_INCOME":
      return { ...state, isFetchingOtherPartyIncome: false };

    //INCOME

    case "REQUEST_INCOME":
      return { ...state, isFetchingIncome: true };
    case "SUCCESS_INCOME":
      return {
        ...state,
        income: {
          salaryWages: {
            lastMonth: action.payload.lastMonthSalary,
            averageMonthally: action.payload.averageMonthSalary,
          },
          overtime: {
            lastMonth: action.payload.lastMonthOvertime,
            averageMonthally: action.payload.averageOvertime,
          },
          commissions: {
            lastMonth: action.payload.lastMonthCommission,
            averageMonthally: action.payload.averageCommission,
          },
          publicAssistance: {
            currentlyReceivingCheck: action.payload.currentlyReceiving,
            lastMonth: action.payload.publicAssistanceLastMonth,
            averageMonthally: action.payload.averagePublicAssistance,
          },
          spousalSuport: {
            spousalSuportCheck: action.payload.spousalSupport,
            lastMonth: action.payload.spousalSupportLastMonth,
            averageMonthally: action.payload.averageSpousalSupport,
          },
          partnerSupport: {
            partnerSupportCheck: action.payload.partnerSupport,
            lastMonth: action.payload.lastMonthPartnerSupport,
            averageMonthally: action.payload.averagePartnerSupport,
          },
          socialSecurity: {
            lastMonth: action.payload.lastMonthSecurityRetirement,
            averageMonthally: action.payload.averageSecurityRetirement,
          },
          disability: {
            disabilityCheck: action.payload.disability,
            lastMonth: action.payload.lastMonthDisability,
            averageMonthally: action.payload.averageDisability,
          },
          pensionRetirementFund: {
            lastMonth: action.payload.lastMonthPension,
            averageMonthally: action.payload.averagePension,
          },
          unemploymentCompensation: {
            lastMonth: action.payload.lastMonthUnemployment,
            averageMonthally: action.payload.averageUnemployment,
          },
          WorkerCompensation: {
            lastMonth: action.payload.lastMonthWorkersCompensation,
            averageMonthally: action.payload.averageWorkersCompensation,
          },
          others: {
            specific: action.payload.militaryAllowances,
            lastMonth: action.payload.lastMonthMilitaryAllowances,
            averageMonthally: action.payload.averageMilitaryAllowances,
          },
        },
        isFetchingIncome: false,
      };
    case "ERROR_INCOME":
      return { ...state, isFetchingIncome: false };

    //Invest Income

    case "REQUEST_INVEST_INCOME":
      return { ...state, isFetchingInvestIncome: true };
    case "SUCCESS_INVEST_INCOME":
      return {
        ...state,
        investmentIncome: {
          dividendsInterest: {
            lastMonth: action.payload.lastMonthDividends,
            averageMonthally: action.payload.averageDividends,
          },
          rentalPropertyIncome: {
            lastMonth: action.payload.lastMonthRentalProperty,
            averageMonthally: action.payload.averageRentalProperty,
          },
          trustIncome: {
            lastMonth: action.payload.trustLastMonth,
            averageMonthally: action.payload.trustAverageMonthly,
          },
          otherIncome: {
            specific: action.payload.other,
            lastMonth: action.payload.otherLastMonth,
            averageMonthally: action.payload.otherIncomeAverageMonthly,
          },
        },
        isFetchingInvestIncome: false,
      };
    case "ERROR_INVEST_INCOME":
      return { ...state, isFetchingInvestIncome: false };

    //Additional Income
    case "REQUEST_SELF_EMPLOYEED_INCOME":
      return { ...state, isFetchingEmplayedIncome: true };
    case "SUCCESS_SELF_EMPLOYEED_INCOME":
      return {
        ...state,
        IncomeFromSelfEmployment: {
          selfEmployementType: {
            selfEmployementTypeStatus: action.payload.selfEmployment,
            bussinessPartner: {
              specify: action.payload.selfEmploymentOther,
            },
          },
          yearsOfBusiness: action.payload.bussinessYears,
          businessName: action.payload.nameOfBusiness,
          businessType: action.payload.typeOfBusiness,
        },
        isFetchingEmplayedIncome: false,
      };
    case "ERROR_SELF_EMPLOYEED_INCOME":
      return { ...state, isFetchingEmplayedIncome: false };

    //Change In Income
    case "REQUEST_CHANGE_IN_INCOME":
      return { ...state, isFetchingChangeInIncome: true };
    case "SUCCESS_CHANGE_IN_INCOME":
      return {
        ...state,
        changeInIncome: action.payload.changeInIncome,
        isFetchingChangeInIncome: false,
      };
    case "ERROR_CHANGE_IN_INCOME":
      return { ...state, isFetchingChangeInIncome: false };

    //Deductions

    case "REQUEST_DEDUCTIONS":
      return { ...state, isFetchingDeductions: true };
    case "SUCCESS_DEDUCTIONS":
      return {
        ...state,
        deductions: {
          requiredUnionDues: {
            lastMonth: action.payload.lastMonthRequiredUnionDues,
          },
          requiredRetirementPay: {
            lastMonth: action.payload.lastMonthRequiredRetirementPayments,
          },
          healthExpenses: {
            lastMonth: action.payload.lastMonthHealthInsurance,
          },
          childSupport: {
            lastMonth: action.payload.lastMonthChildSupport,
          },
          spousalSupport: {
            lastMonth: action.payload.spousalSupportAnotherMarriage,
            federallytax: action.payload.taxDeductible,
          },
          partnerSupport: {
            lastMonth: action.payload.partnerSupportAnotherMarriage,
          },
          jobExpenses: {
            lastMonth: action.payload.lastMonthJobRelated,
          },
        },
        isFetchingDeductions: false,
      };
    case "ERROR_DEDUCTIONS":
      return { ...state, isFetchingDeductions: false };

    //Asset

    case "REQUEST_ASSET":
      return { ...state, isFetchingAsset: true };
    case "SUCCESS_ASSET":
      return {
        ...state,
        assets: {
          accounts: {
            lastMonth: action.payload.cashCheckcashCheck,
          },
          stockBonds: {
            lastMonth: action.payload.lastMonthStockslastMonthStocks,
          },
          otherPropert: {
            type: action.payload.assetsOtherassetsOther,
            lastMonth: action.payload.lastMonthAssetsOtherlastMonthAssetsOther,
          },
        },
        isFetchingAsset: false,
      };
    case "ERROR_ASSET":
      return { ...state, isFetchingAsset: false };

    //Average Monthallay Expense
    case "REQUEST_AVERAGE_MONTHALLY_EXPENSE":
      return { ...state, isFetchingAverageMonthallyExpense: true };
    case "SUCCESS_AVERAGE_MONTHALLY_EXPENSE":
      return {
        ...state,

        averageMonthallyExpenses: {
          home: {
            homeStatus: {
              averageMonthlyExpenseBox: action.payload.averageMonthlyExpenseBox,
              rent: action.payload.home,
              mortgage: {
                averagePrincipal: action.payload.averagePrincipal,
                averageIntrest: action.payload.averageInterest,
              },
              rental:{
                rentalCost: action.payload.rentalCost,
              },
            },
            realPropertyTax: {
              lastMonth: action.payload.lastMonthRealProperty,
            },
            homeOwnerInsurance: {
              lastMonth: action.payload.lastMonthHomeOwner,
            },
            maintainance: {
              lastMonth: action.payload.lastMonthMaintenance,
            },
          },
          healthCareCost: {
            lastMonth: action.payload.lastMonthHealthCare,
          },
          childCareCost: {
            lastMonth: action.payload.lastMonthChildCare,
          },
          householdSupplies: {
            lastMonth: action.payload.lastMonthGroceriesSupplies,
          },
          eatingOut: {
            lastMonth: action.payload.lastMonthEatingOut,
          },
          utilities: {
            lastMonth: action.payload.lastMonthUtilities,
          },
          telephone: {
            lastMonth: action.payload.lastMonthTelephone,
          },
          laundaryCleaning: {
            lastMonth: action.payload.laundryLaundry,
          },
          clothes: {
            lastMonth: action.payload.lastMonthClothes,
          },
          education: {
            lastMonth: action.payload.lastMonthEducation,
          },
          entertainment: {
            lastMonth: action.payload.lastMonthEntertainment,
          },
          transportation: {
            lastMonth: action.payload.lastMonthTransportation,
          },
          insurance: {
            lastMonth: action.payload.lastMonthInsurance,
          },
          savingsInvestments: {
            lastMonth: action.payload.lastMonthSavings,
          },
          charitableContributions: {
            lastMonth: action.payload.charitableCharitable,
          },
          monthallyPayments: {
            lastMonth: action.payload.monthlyPaymentsMonthlyPayments,
          },
          others: {
            specific: action.payload.monthallyExpenseOther,
            lastMonth: action.payload.lastMonthMonthallyExpenseOther,
          },
          totalExpense: action.payload.lastMonthTotalExpenses,
          amountPaidByOthers: action.payload.lastMonthAmountOfExpenses,
        },
        isFetchingAverageMonthallyExpense: false,
      };
    case "ERROR_AVERAGE_MONTHALLY_EXPENSE":
      return { ...state, isFetchingAverageMonthallyExpense: false };

    //Attorney Fee

    case "REQUEST_ATTORNEY_FEE":
      return { ...state, isFetchingAttorneyFee: true };
    case "SUCCESS_ATTORNEY_FEE":
      return {
        ...state,
        attorneyFees: {
          no: action.payload.attorneyFee,
          yes: {
            attorneyMonthallyFees: {
              lastMonth: action.payload.dateAttorneyFeePaid,
            },
            sourceOfMoney: action.payload.sourceOfMoney,
            totalOwedFee: {
              lastMonth: action.payload.stillOwe,
            },
            attorneyHourlyRate: {
              lastMonth: action.payload.hourlyRate,
            },
          },
        },
        isFetchingAttorneyFee: false,
      };
    case "ERROR_ATTORNEY_FEE":
      return { ...state, isFetchingAttorneyFee: false };

    //NUMBER OF CHILDREN

    case "REQUEST_NUMBER_OF_CHILDREN":
      return { ...state, isFetchingNumberOfChildre: true };
    case "SUCCESS_NUMBER_OF_CHILDREN":
      return {
        ...state,
        numberOfChildren: {
          NumberOfunderAgeChild: action.payload.numberOfChildren,
          timeSpendWithYouPercentage: action.payload.timeWithYou,
          timeSpendWithSpousePercentage: action.payload.timeWithOther,
        },
        isFetchingNumberOfChildre: false,
      };
    case "ERROR_NUMBER_OF_CHILDREN":
      return { ...state, isFetchingNumberOfChildre: false };

    //CHILD HEALTH EXPENSES
    case "REQUEST_CHILD_HEALTH_EXPENSES":
      return { ...state, isFetchingChildHealthExpense: true };
    case "SUCCESS_CHILD_HEALTH_EXPENSES":
      return {
        ...state,
        childHealthCareExpense: {
          no: action.payload.healthInsurance,
          yes: {
            insuranceCompanyName: action.payload.insuranceCompany,
            insuranceCompanyAddress: action.payload.insuranceCompanyAddress,
            monthallyCost: action.payload.monthlyCost,
          },
        },
        isFetchingChildHealthExpense: false,
      };
    case "ERROR_CHILD_HEALTH_EXPENSES":
      return { ...state, isFetchingChildHealthExpense: false };

    //Child Additional Expense

    case "REQUEST_CHILD_ADDITIONAL_EXPENSES":
      return { ...state, isFetchingChildAdditionalExpense: true };
    case "SUCCESS_CHILD_ADDITIONAL_EXPENSES":
      return {
        ...state,
        additionalChildExpense: {
          childCare: action.payload.lastChildCareExpense,
          childHealthCare: action.payload.lastChildrenHealthAmount,
          childTravelExpense: action.payload.lastChildTravelExpenses,
          childOtherSpecialNeeds: {
            specific: action.payload.educationalNeeds,
            lastMonth: action.payload.MonthallyeducationalNeeds,
          },
        },
        isFetchingChildAdditionalExpense: false,
      };
    case "ERROR_CHILD_ADDITIONAL_EXPENSES":
      return { ...state, isFetchingChildAdditionalExpense: false };

    //Special hardship

    case "REQUEST_SPECIAL_HARDSHIP":
      return { ...state, isFetchingSpecialHardship: true };
    case "SUCCESS_SPECIAL_HARDSHIP":
      return {
        ...state,
        specialHardship: {
          childrenSpecify: action.payload.childrenSpecify,
          extraHealthExpenses: {
            lastMonth: action.payload.lastExtraHealthExpenses,
            averageMonthally: action.payload.monthsForExtraHealthExpenses,
          },

          majorLoss: {
            lastMonth: action.payload.PerMonthMajorLosses,
            averageMonthally: action.payload.monthForMajorLosses,
          },

          minorChildExpense: {
            lastMonth: action.payload.PerMinorChildExpenses,
            averageMonthally: action.payload.expenses,
            // namesAndAges: action.payload.,
          },
          minorChildSupport: action.payload.monthallyChildSupport,
          financialHardshipExplain: action.payload.extremeFinancialHardship,
        },
        isFetchingSpecialHardship: false,
      };
    case "ERROR_SPECIAL_HARDSHIP":
      return { ...state, isFetchingSpecialHardship: false };

    //Other Information

    case "REQUEST_OTHER_INFORMATION":
      return { ...state, isFetchingOtherInformation: true };
    case "SUCCESS_OTHER_INFORMATION":
      return {
        ...state,
        otherInfoForCourt: action.payload.otherCourtInfo,
        isFetchingOtherInformation: false,
      };
    case "ERROR_OTHER_INFORMATION":
      return { ...state, isFetchingOtherInformation: false };





    case "REQUEST_ADDITIONAL_INCOME":
      return { ...state, isFetchingAdditionalIncome: true };
    case "SUCCESS_ADDITIONAL_INCOME":
      return {
        ...state,
        oneTimeMoney: {
          specific: action.payload.oneTimeMoney,
        },
        isFetchingAdditionalIncome: false,
      };
    case "ERROR_ADDITIONAL_INCOME":
      return { ...state, isFetchingAdditionalIncome: false };



    case "REQUEST_PEOPLE_LIVE":
      return { ...state, isFetchingPeopleLive: true };
    case "SUCCESS_PEOPLE_LIVE":
      return {
        ...state,
        isFetchingPeopleLive: false,
        peopleLive: isEmpty(action.payload.data) ? initialState.peopleLive: action.payload.data,
      };
    case "ERROR_PEOPLE_LIVE":
      return { ...state, isFetchingPeopleLive: false };




    case "REQUEST_INSTALLMENT_PAYMENTS":
      return { ...state, isFetchingInstallmentPayments: true };
    case "SUCCESS_INSTALLMENT_PAYMENTS":
      return {
        ...state,
        isFetchingInstallmentPayments: false,
        installmentPayments: isEmpty(action.payload.data) ? initialState.installmentPayments: action.payload.data,
      };
    case "ERROR_INSTALLMENT_PAYMENTS":
      return { ...state, isFetchingInstallmentPayments: false };


      case "REQUEST_DELETE_PEOPLE_LIVE":
        return { ...state, isFetchingDeletePeopleLive: true };
      case "SUCCESS_DELETE_PEOPLE_LIVE":
        return {
          ...state,
          isFetchingDeletePeopleLive: false,
          peopleLive: isEmpty(action.payload.data) ? initialState.peopleLive: action.payload.data,
        };
      case "ERROR_DELETE_PEOPLE_LIVE":
        return { ...state, isFetchingDeletePeopleLive: false };


        case "REQUEST_DELETE_INSTALLMENT":
          return { ...state, isFetchingDeleteInstallment: true };
        case "SUCCESS_DELETE_INSTALLMENT":
          return {
            ...state,
            isFetchingDeleteInstallment: false,
            installmentPayments: isEmpty(action.payload.data) ? initialState.installmentPayments: action.payload.data,
          };
        case "ERROR_DELETE_INSTALLMENT":
          return { ...state, isFetchingDeleteInstallment: false };


    default:
      return state;
  }
};

export default AssestsDebitsReducer;
